/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Share_Code_ExampleInputs */

const en_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 32a9599f-9670-47a1-8746-1cd0591f3262`)
};

const fr_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. 32a9599f-9670-47a1-8746-1cd0591f3262`)
};

const de_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. 32a9599f-9670-47a1-8746-1cd0591f3262`)
};

const it_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per esempio. 32a9599f-9670-47a1-8746-1cd0591f3262`)
};

const ru_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например 32a9599f-9670-47a1-8746-1cd0591f3262`)
};

const es_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p.ej. 32a9599f-9670-47a1-8746-1cd0591f3262`)
};

const zh_cn2_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如32a9599f-9670-47a1-8746-1cd0591f3262`)
};

const ja_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例えば32a9599f-9670-47a1-8746-1cd0591f3262`)
};

const hi_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जैसे 32a9599f-9670-47a1-8746-1cd0591f3262`)
};

const pt_pt2_team_project_import_share_code_example = /** @type {(inputs: Team_Project_Import_Share_Code_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por exemplo 32a9599f-9670-47a1-8746-1cd0591f3262`)
};

/**
* | output |
* | --- |
* | "e.g. 32a9599f-9670-47a1-8746-1cd0591f3262" |
*
* @param {Team_Project_Import_Share_Code_ExampleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_share_code_example = /** @type {((inputs?: Team_Project_Import_Share_Code_ExampleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Share_Code_ExampleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_share_code_example(inputs)
	if (locale === "de") return de_team_project_import_share_code_example(inputs)
	if (locale === "it") return it_team_project_import_share_code_example(inputs)
	if (locale === "ru") return ru_team_project_import_share_code_example(inputs)
	if (locale === "es") return es_team_project_import_share_code_example(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_share_code_example(inputs)
	if (locale === "ja") return ja_team_project_import_share_code_example(inputs)
	if (locale === "hi") return hi_team_project_import_share_code_example(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_share_code_example(inputs)
	return en_team_project_import_share_code_example(inputs)
});